import { Injectable, signal, computed } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cache = new Map<string, HttpResponse<any>>();
  
  public cacheCleared = signal<number>(0);
  
  public cacheSize = computed(() => {
    this.cacheCleared();
    return this.cache.size;
  });

  public get(key: string): HttpResponse<any> | undefined {
    return this.cache.get(key);
  }

  public set(key: string, response: HttpResponse<any>): void {
    this.cache.set(key, response);
  }

  public delete(key: string): void {
    this.cache.delete(key);
  }

  public getCache(): Map<string, HttpResponse<any>> {
    return this.cache;
  }

  public clearAll(): void {
    this.cache.clear();
    this.cacheCleared.update(count => count + 1);
  }

  public clearByPattern(pattern: RegExp): void {
    const keysToDelete: string[] = [];
    
    for (const key of this.cache.keys()) {
      if (pattern.test(key)) {
        keysToDelete.push(key);
      }
    }
    
    for (const key of keysToDelete) {
      this.cache.delete(key);
    }
    
    if (keysToDelete.length > 0) {
      this.cacheCleared.update(count => count + 1);
    }
  }

  public clearOrganizationData(): void {
    this.clearByPattern(/\/(members|properties|organizations\/\d+|charge-schedules|balances)/i);
  }

  public has(key: string): boolean {
    return this.cache.has(key);
  }
}
